// extracted by mini-css-extract-plugin
export default {"playerWrapper":"Player_playerWrapper__loPnd","trackNameWrapper":"Player_trackNameWrapper__RMglL","trackName":"Player_trackName__rWwto","closeIcon":"Player_closeIcon__+BClj"};